/**
 * Fire-and-forget reporting of usage + health events to the backend EventLog.
 * Never throws and never blocks the UI — tracking must not break the app. Only
 * authenticated sessions are tracked (no token → no-op).
 */
import { API } from "../config/api"

const TOKEN_KEY = "invi_token"

async function postEvent(path: string, body: object): Promise<void> {
  const token = localStorage.getItem(TOKEN_KEY)
  if (!token) return
  try {
    await fetch(`${API.baseUrl}${path}`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      body: JSON.stringify(body),
      keepalive: true, // let the report finish even if the page is navigating away
    })
  } catch {
    // Swallow — a failed tracking call must never surface to the user.
  }
}

export function recordPageView(routePath: string): void {
  void postEvent(API.endpoints.events.pageView, { path: routePath })
}

export interface ClientErrorReport {
  event_type?: "client_error" | "api_error"
  path?: string | null
  status_code?: number | null
  message?: string | null
}

export function recordError(report: ClientErrorReport): void {
  void postEvent(API.endpoints.events.error, {
    event_type: report.event_type ?? "client_error",
    path: report.path ?? null,
    status_code: report.status_code ?? null,
    message: report.message ?? null,
  })
}
